module.exports = __webpack_public_path__ + "static/media/KMH_5380.67970882.jpg";